import config3 from './3.js'
import config4 from './4.js'
import config5 from './5.js'

function createCourse({ title, list, id }) {
  let courseId = id
  let str = `<div class="along-wrap">
      <div class="along-title-wrap">
          <h2 class="along-title">${title}</h2>
      </div>
  `
  str += list.reduce((str, el) => {
    let html_str = createContent({ courseId, ...el })
    str += `<div class="along-cell-wrap">${html_str}</div>`
    return str
  }, '')
  str += '</div>'
  return str.replace(/\n/g, '')
}

//  `内的换行 \n 会被保留下来`
function createContent({
  courseId,
  title,
  strongId,
  titleTag = 'h3',
  titleClass = '',
  id,
  content,
}) {
  let id_str = `course${courseId && `_${courseId}`}_${id}`
  if (strongId) id_str = `${strongId}`
  let titleClass_str = `along-cell-title ${titleClass}`
  return `<${titleTag} id="${id_str}" class="${titleClass_str}">
      <div class="along-cell-tip">问</div>
      <div class="along-cell-txt">${title}</div>
  </${titleTag}>
  <div class="along-content-wrap">
      <div class="along-cell-tip the-success">答</div>
      <div class="along-cell-txt">${content}</div>
  </div>`
}

export const createTutorialDetail = (id) => {
  const configMap = {
    3: config3,
    4: config4,
    5: config5,
  }
  const config = configMap[id];
  return  {
    content: createCourse(config),
    id,
    title: config.title,
  }
}

/* export default {
  createTutorialDetailHtml,
  createCourse,
  createContent
}
 */